<template>
  <div class="badlist">
    <SidebarLayout2
      :breadcrumb="breadcrumb"
      :pageTitle="pageTitle"
      class="badlist--sidebar"
    >
      <!-- BARRA LATERAL -->
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock>
          <PmwHeading size="paragraph-40">Ações da página</PmwHeading>
          <!-- BOTÕES DE AÇÃO -->
          <div class="badlist--action">
            <PmwButton
              :hasIcon="true"
              :link="'/badlist/create'"
              element="router-link"
              variation="blue-100"
              class="action-button"
            >
              Incluir na badlist
            </PmwButton>
            <PmwButton
              :disabled="unlockBtn"
              variation="blue-100"
              class="action-button"
              @click="goToEditUser"
            >
              Editar
            </PmwButton>
            <PmwButton
              v-if="statusFilter.value"
              :disabled="!selectedUser.length > 0"
              variation="blue-100"
              class="action-button"
              @click="showModal = true"
            >
              Desbloquear
            </PmwButton>
          </div>
        </SidebarBlock>
        <!-- DICAS -->
        <SidebarBlock class="advice">
          <PmwHeading size="paragraph-40"> Dica </PmwHeading>
          <PmwParagraph class="advice--paragraph">
            Revise suas políticas de hospedagem para contemplar os motivos do
            hóspede ser restringido de efetuar novas reservas.
          </PmwParagraph>
        </SidebarBlock>
      </template>
      <!-- CONTEÚDO -->
      <template #content>
        <PmwParagraph size="paragraph-80" class="badlist--subtitle">
          Listagem de hóspedes que estão bloqueados para efetuar novas reservas.
        </PmwParagraph>
        <SearchInput
          v-model="searchTerm"
          placeholder="Buscar os dados do hóspede"
          class="badlist--search"
          @input="searchData"
        />

        <FilterDropdown
          v-model="statusFilter"
          :options="statusOption"
          class="badlist--input-select"
          @input="getBadlist"
        />

        <DataTable
          :cols="cols"
          :rows="rows"
          :colsMinWidths="colsMinWidths"
          :selectableRow="true"
          :selectedRowHasBgColor="true"
          :sortable="true"
          :isLoading="isLoading"
          :searchableColumns="['tipo', 'valor', 'motivo']"
          notFoundMessage="Não há hóspedes correspondentes com a busca."
          @getSelectedRows="selectedUser = $event"
        >
          <template v-slot:motivo="slotProps">
            <div
              :class="{
                'badlist--data-table__white': slotProps.rowDataObj.checked
              }"
            >
              {{
                slotProps.rowDataObj.motivo.length > 50
                  ? slotProps.rowDataObj.motivo.substring(0, 50) + '...'
                  : slotProps.rowDataObj.motivo
              }}
            </div>
          </template>
          <template v-slot:valor="slotProps">
            {{
              slotProps.rowDataObj.valor.length > 20
                ? slotProps.rowDataObj.valor.substring(0, 20) + '...'
                : slotProps.rowDataObj.valor
            }}
          </template>
          <template v-slot:editar="slotProps">
            <router-link
              :to="`/badlist/editar/${slotProps.rowDataObj.codigo}`"
              :class="[
                'badlist--data-table',
                'badlist--data-table__action',
                { 'badlist--data-table__white': slotProps.rowDataObj.checked }
              ]"
            >
              Editar
            </router-link>
          </template>
          <template v-slot:action="slotProps">
            <div
              v-if="slotProps.rowDataObj.ativo"
              :class="[
                'badlist--data-table',
                'badlist--data-table__action',
                { 'badlist--data-table__white': slotProps.rowDataObj.checked },
                {
                  'badlist--data-table__not-active': !slotProps.rowDataObj.ativo
                }
              ]"
              @click="unlockAllSelectedUser(slotProps.rowDataObj)"
            >
              <span> Desbloquear </span>
            </div>
            <div
              v-else
              :class="[
                'badlist--data-table',
                'badlist--data-table__action',
                { 'badlist--data-table__white': slotProps.rowDataObj.checked },
                {
                  'badlist--data-table__not-active': !slotProps.rowDataObj.ativo
                }
              ]"
              @click="lockSelectedUser(slotProps.rowDataObj)"
            >
              <span> Bloquear </span>
            </div>
          </template>
        </DataTable>

        <PmwPagination
          v-show="paginationItems.length > 25"
          :currentPage="pagination.currentPage"
          :itemsPerPage="pagination.itemsPerPage"
          :itemsPerPageOptions="pagination.itemsPerPageOptions"
          :items="paginationItems"
          :totalItems="pagination.totalItems"
          @changePagination="changePagination"
        />

        <!-- MODAL DE CONFIRMAÇÃO -->
        <PmwAlertModal
          v-model="showModal"
          :title="''"
          closeButton
          icon="lock-open"
          cancelButtonText="Voltar"
          confirmButtonText="Desbloquear"
          confirmButtonColor="blue-100"
          @alert-modal-confirm="unlockSelectedUser"
          @alert-modal-cancel="showModal = false"
        >
          <template #text>
            <div class="modal--container-content">
              <PmwHeading class="modal--title">Desbloquear hóspede</PmwHeading>
              <PmwParagraph size="paragraph-60" class="modal--paragraph">
                Ao desbloquear o hóspede, ele poderá efetuar reservas novamente.
              </PmwParagraph>
            </div>
          </template>
        </PmwAlertModal>
      </template>
    </SidebarLayout2>
  </div>
</template>

<script>
import SidebarLayout2 from '@/layouts/SidebarLayout2'
import SidebarBlock from '@solucoes/components-lib-tmp/src/components/patterns/SidebarBlock'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwButton from '@solucoes/components-lib-tmp/src/components/elements/PmwButton'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import SearchInput from '@solucoes/components-lib-tmp/src/components/elements/SearchInput'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import PmwPagination from '@solucoes/components-lib-tmp/src/components/patterns/PmwPagination'
import PmwAlertModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwAlertModal'
import FilterDropdown from '@solucoes/components-lib-tmp/src/components/patterns/FilterDropdown'

export default {
  name: 'BadListView',
  components: {
    SidebarLayout2,
    SidebarBlock,
    PmwHeading,
    PmwButton,
    PmwParagraph,
    SearchInput,
    DataTable,
    PmwPagination,
    PmwAlertModal,
    FilterDropdown
  },

  data() {
    return {
      /** Configuração da página */
      pageTitle: 'Badlist',

      /** Caminhos da página */
      breadcrumb: [
        {
          label: 'Configurações',
          url: '',
          isSpa: false /** se deve ser um link para o site novo ou antigo  */
        },
        {
          label: 'Badlist',
          url: '/badlist',
          isSpa: true /** se deve ser um link para o site novo ou antigo  */
        }
      ],

      /** Palavra pesquisada */
      searchTerm: '',

      /** Usuário ou Usuários selecionados */
      selectedUser: [],

      /** Controla disabled do botao de desbloquear */
      unlockBtn: true,

      cols: [
        /** colunas do grid */
        { name: 'tipo', alias: 'Tipo de dado', sortable: true },
        { name: 'valor', alias: 'Dado do hóspede', sortable: true },
        { name: 'motivo', alias: 'Motivo do Bloqueio', sortable: true },
        { name: 'tentativas', alias: 'Nº de tentativas', sortable: true },
        { name: 'editar', alias: 'Ações', sortable: false },
        { name: 'action', sortable: false }
      ],

      rows: [],

      paginationItems: [],

      colsMinWidths: {
        motivo: '350px',
        tipo: '120px',
        tentativas: '90px',
        editar: '70px',
        desbloquear: '90px'
      },

      pagination: {
        currentPage: 1,
        itemsPerPage: 25,
        itemsPerPageOptions: [
          {
            text: '25',
            value: 25
          },
          {
            text: '50',
            value: 50
          },
          {
            text: '100',
            value: 100
          }
        ],
        totalItems: 0
      },

      isLoading: false,

      showModal: false,

      statusValue: '',

      statusOption: [
        { label: 'Bloqueado', value: true, checked: true },
        { label: 'Desbloqueado', value: false, checked: false }
      ],

      /** V-model do filtro de status */
      statusFilter: { label: 'Bloqueado', value: true, checked: true }
    }
  },

  mounted() {
    this.getBadlist()
  },

  watch: {
    statusFilter() {
      this.searchTerm = ''
    },

    /**
     * Habilita ou desabilita o botao de desbloqueio baseado na quantidade de hóspedes selecionados
     * @param {Array} newValue: Array com hóspedes selecionados
     */
    selectedUser(newValue) {
      if (newValue.length === 1 && newValue.length < 2) {
        this.unlockBtn = false
      } else {
        this.unlockBtn = true
      }
    },

    /**
     * Volta a paginação ao inicio quando pesquisar
     * @param {String} newValue: String pesquisada na busca de dados
     */
    searchTerm(newValue) {
      if (newValue === '') {
        this.pagination.currentPage = 1
      }
    }
  },

  methods: {
    /** Pesquisa pelo dado do hóspede, motivo ou tipo */
    searchData() {
      const searchTerm = this.searchTerm ? this.searchTerm.toLowerCase() : ''
      this.rows = this.paginationItems.filter((item) => {
        return (
          item.data.valor.toLowerCase().includes(searchTerm) ||
          item.data.motivo.toLowerCase().includes(searchTerm) ||
          item.data.tipo.toLowerCase().includes(searchTerm)
        )
      })
    },

    /**
     * Bloqueia o usuário da lista
     * @param {Object} selectedUser: Objeto representa usuario clicado
     */
    lockSelectedUser(selectedUser) {
      this.$badlist
        .updateUserBadlist({
          tipo: selectedUser.tipo,
          valor: selectedUser.valor,
          motivo: selectedUser.motivo,
          codigo: selectedUser.codigo,
          ativo: true
        })
        .then(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Hóspede bloqueado com sucesso!'
          })

          this.getBadlist()
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao bloquear hóspede'
          })
        })
    },

    /**
     * Desbloqueia o usuário da lista
     * @param {Object} selectedUser: Objeto com usuário selecionado
     */
    unlockAllSelectedUser(selectedUser) {
      this.showModal = true
      this.selectedUser = selectedUser
    },

    /**
     * Desativa o usuário da badlist
     */
    unlockSelectedUser() {
      let dataDelete
      if (Array.isArray(this.selectedUser)) {
        dataDelete = this.selectedUser.map((a) => a.codigo)
      } else {
        dataDelete = this.selectedUser.codigo
      }

      this.$badlist
        .deleteUserBadList(dataDelete)
        .then(() => {
          this.showModal = false
          this.getBadlist()
          this.$bus.$emit('show-alert-chip', {
            message: 'Hóspede desbloqueado com sucesso!'
          })
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro ao desbloquear hóspede'
          })
        })
    },

    /** Função chamada ao editar um hóspede selecionado */
    goToEditUser() {
      if (this.selectedUser) {
        this.$badlist.getBadlistById().then(() => {
          this.$router.push({
            path: `/badlist/editar/${this.selectedUser[0].codigo}`
          })
        })
      }
    },

    /** Atualiza a lista da badlist */
    getBadlist() {
      this.selectedUser = []

      this.unlockBtn = false

      this.isLoading = true

      this.$badlist
        .getBadlist(this.statusFilter.value, this.searchTerm)
        .then((response) => {
          const data = response.data

          this.paginationItems = this.standarizeTableData(data)

          this.pagination.totalItems = data.length
        })
        .catch(() => {
          this.$bus.$emit('show-alert-chip', {
            message: 'Erro carregar a badlist'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },

    /**
     * Maneja a paginação
     * @param {Object} event: dados da paginação
     */
    changePagination(event) {
      this.pagination.currentPage = event.currentPage
      this.rows = event.items
      toString(this.rows)
    },

    /**
     *  Padroniza os dados para a tabela
     *  @param {Array} items: dados que serão tratados
     *  @returns array com os dados padronizados
     */
    standarizeTableData(items) {
      return items.map((item) => {
        return {
          data: {
            tipo: item.tipo,
            codigo: item.codigo,
            valor: item.valor,
            motivo: item.motivo,
            tentativas: item.tentativas,
            ativo: item.ativo
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.badlist {
  ::v-deep .pmw-row .pmw-label {
    display: contents;
    line-height: 18px;
  }

  &--data-table {
    font-weight: font-weight('weight-normal');
    &__action {
      color: pmw-colors('blue-100');
      cursor: pointer;
    }
    &__white {
      color: $pmw-white;
    }

    &__not-active {
      color: pmw-colors('red-100');
    }

    &:hover {
      color: $pmw-gray-darkest;
    }
  }

  &--action {
    .action-button {
      margin-bottom: 6px;
    }
  }

  .advice {
    &--paragraph {
      line-height: 21px;
    }
  }

  &--subtitle {
    margin-top: -40px;
    margin-bottom: 35px;
  }

  &--search {
    max-width: 273px;
    margin-bottom: 20px;
  }

  &--input-select {
    width: 162px;
    margin-bottom: 25px;
  }
}

.modal {
  &--img {
    margin-top: -50px;
    margin-bottom: 20px;
  }
}

::v-deep .pmw-datatable-wrapper__overflow {
  .pmw-col.pmw-th:nth-child(6) {
    border-right: none;
  }

  .pmw-td:nth-child(6) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
